import { createBrowserRouter, Link } from 'react-router-dom';
import { CallbackPage } from './auth/CallbackPage.js';
import { SilentRenewPage } from './auth/SilentRenewPage.js';
import { Layout } from './components/Layout.js';
import { ProtectedRoute, RoleRoute } from './components/ProtectedRoute.js';
import { ApplicationDetailPage } from './pages/ApplicationDetailPage.js';
import { CandidatesPage } from './pages/CandidatesPage.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { JobDetailPage } from './pages/JobDetailPage.js';
import { JobsPage } from './pages/JobsPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { PipelinePage } from './pages/PipelinePage.js';
import { SettingsPage } from './pages/SettingsPage.js';

function NotFoundPage() {
  return (
    <div className="route-center">
      <div className="empty-state">
        <h2>Page not found</h2>
        <p>
          <Link to="/">Back to the dashboard</Link>
        </p>
      </div>
    </div>
  );
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/auth/callback', element: <CallbackPage /> },
  { path: '/auth/silent-renew', element: <SilentRenewPage /> },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'pipeline', element: <PipelinePage /> },
      { path: 'jobs', element: <JobsPage /> },
      { path: 'jobs/:jobId', element: <JobDetailPage /> },
      { path: 'candidates', element: <CandidatesPage /> },
      { path: 'applications/:applicationId', element: <ApplicationDetailPage /> },
      {
        path: 'settings',
        element: (
          <RoleRoute roles={['admin']}>
            <SettingsPage />
          </RoleRoute>
        ),
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
